var path = 'components/side-menu.tpl.html';
var html = " <ul flex layout=column layout-align=\"start stretch\" class=tb-side-menu> <li ng-repeat=\"section in sections\" class=parent-list-item ng-class=\"{'parentActive' : isOpen(section)}\"> <tb-menu-link section=section></tb-menu-link> </li> </ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/side-menu.tpl.html
// module id = 1402
// module chunks = 1